export const progressStepList = ['Extracting', 'Preparing', 'Analyzing', 'Grouping', 'Validating', 'Completed'];

export function updateTaskProgressStep(task) {
  const currentTime = new Date().getTime();
  let progress_step = {
    step: 0,
    isProcessing: false,
    displayStatus: task.status,
    currentStepColor: '',
    activeIconClass: '',
  };

  // Same logic as in the original updateTaskProgressStep
  if (task.status === 'processing' || task.status === 'completed') {
    progress_step.isProcessing = true;
    const processTime = new Date(task.process_time).getTime();
    const timeDiffSeconds = (currentTime - processTime) / 1000;
    progress_step.step = 2;
    if (timeDiffSeconds < 20) {
      progress_step.step = 0;
    } else if (timeDiffSeconds < 40) {
      progress_step.step = 1;
    } else if (timeDiffSeconds < 60) {
      progress_step.step = 2;
    } else if (task.status === 'completed') {
      let processFinishedTime = new Date(task.process_finish_time).getTime();
      if (processFinishedTime < processTime + 60 * 1000) {
        processFinishedTime = processTime + 60 * 1000;
      }
      const timeDiffSeconds = (currentTime - processFinishedTime) / 1000;
      if (timeDiffSeconds < 10) {
        progress_step.step = 3;
      } else if (timeDiffSeconds < 15) {
        progress_step.step = 4;
      } else {
        progress_step.currentStepColor = 'green';
        progress_step.isProcessing = false;
        progress_step.step = progressStepList.length - 1;
      }
    }
    else {
      progress_step.step = 2;
    }
    progress_step.displayStatus = progressStepList[Math.min(progress_step.step, progressStepList.length - 1)];
  } else if (task.status === 'extract_failed') {
    progress_step.currentStepColor = 'red';
    progress_step.activeIconClass = 'fa fa-times';
    progress_step.step = 2;
    progress_step.displayStatus = 'analysis failed';
  } else if (task.status === 'compare_failed') {
    progress_step.currentStepColor = 'red';
    progress_step.activeIconClass = 'fa fa-times';
    progress_step.step = 4;
    progress_step.displayStatus = 'validate failed';
  } else if (task.status === 'extracted') {
    progress_step.step = 2;
    progress_step.displayStatus = 'analysis finished';
  } else {
    progress_step.step = -1;
  }

  task.progress_step = progress_step;
  return task;
}
